import React from 'react';
import './answerDetail.style.scss';
import { AnswerStatus, QuestionTypes, ReduxState, Question } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { answerItemNodeGenerator } from './data.comp';
import { WSData } from 'scripts/storage';
import { RoutePath } from 'data';
import { extractTitle } from 'scripts/string';

const FormAnswerDetail: React.FC<ConnectedProps<typeof connector>> = function (
    props: ConnectedProps<typeof connector>,
) {
    const lang = props.lang.answerDetail;
    const { form, answer } = useParams<any>();
    const answerDetail = props.answerDetail;
    const time = answerDetail
        ? answerDetail.modified_at
            ? new Date(answerDetail.modified_at).toLocaleString('fa')
            : new Date(answerDetail.created_at).toLocaleString('fa')
        : '';
    const questions: Question[] = [];
    const history = useHistory();
    const title = WSData.getForm(form)?.title;
    answerDetail?.items?.map((item) => {
        if (item.question) {
            if (item.question.input_type !== QuestionTypes.priority) questions.push(item.question);
            else {
                if (!questions.map((i) => i.id).includes(item.question.parent.id))
                    questions.push({ ...item.question.parent, children: [item.question] });
                else {
                    const parent = questions.find((i) => i.id === item.question.parent.id);
                    if (parent) parent.children.push(item.question);
                }
            }
        }
    });

    return (
        <div className="ucheck-kiosk-form-answer-detail-page">
            <div className="header-ws-detail d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                    <i
                        onClick={() => history.push(RoutePath.dashboard.formAnswerList(form))}
                        className="material-icons-outlined"
                    >
                        east
                    </i>
                    <h3>{title}</h3>
                </div>
                <div className="d-flex align-items-center">
                    <i className="material-icons-outlined notification-icon">text_snippet</i>
                </div>
            </div>
            <div className="content">
                <h3>{lang.answerDetail + ' ' + answer}</h3>

                <div className="subtitle">
                    <div
                        className={`status ${
                            answerDetail ? (answerDetail.state !== AnswerStatus.incomplete ? 'active' : '') : 'not-load'
                        }`}
                    >
                        <i className="material-icons-outlined">
                            {answerDetail?.state !== AnswerStatus.incomplete ? 'check_circle_outline' : 'cancel'}
                        </i>
                        <span className={`${answerDetail ? '' : 'ucheck-skeleton'}`}>
                            {answerDetail
                                ? answerDetail.state !== AnswerStatus.incomplete
                                    ? lang.statuses.complete
                                    : lang.statuses.incomplete
                                : ''}
                        </span>
                    </div>
                    <div className="time">
                        <i className="material-icons-outlined">schedule</i>
                        <span className={`${answerDetail ? '' : 'ucheck-skeleton'}`}>{time}</span>
                    </div>
                </div>
                <div className="answers">
                    {answerDetail ? (
                        answerDetail.items?.length ? (
                            <>
                                {questions?.map((item, index) => (
                                    <div className="item" key={index}>
                                        <div className="question">
                                            {item.input_type === QuestionTypes.matrix && item.parent
                                                ? item.parent.title + ' : '
                                                : ''}
                                            {extractTitle(item.title)}
                                        </div>
                                        <div key={index} className="answer">
                                            <span>{item && answerItemNodeGenerator([item], answerDetail?.items)}</span>
                                        </div>
                                    </div>
                                ))}
                            </>
                        ) : (
                            <p className="empty-item-text">{lang.noItems}</p>
                        )
                    ) : (
                        Array.from(Array(10).keys()).map((item, index) => (
                            <div className="item skeleton-item" key={index}>
                                <div
                                    className="question ucheck-skeleton"
                                    style={{ width: (32 + Math.random() * 32).toString() + '%' }}
                                />
                                <div
                                    key={index}
                                    className="answer ucheck-skeleton"
                                    style={{ width: (24 + Math.random() * 56).toString() + '%' }}
                                />
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    answerDetail: state.answerDetail,
    dir: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(FormAnswerDetail);
